import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import store from './store/store';
import 'babel-polyfill';
import cyd2 from './CommonFeature/features/Cydeen2.vue';
import vueSmoothScroll from 'vue-smooth-scroll';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import 'formdata-polyfill';

Vue.use(Vuex);
Vue.use(vueSmoothScroll);

import vInput from './CommonUtils/basics/VariableInput.vue';
Vue.component('fc-text', vInput);

import vPostal from './CommonUtils/basics/VariablePostalCode.vue';
Vue.component('fc-postal', vPostal);

import vSelect from './CommonUtils/basics/VariableSelect.vue';
Vue.component('fc-select', vSelect);

import vRadio from './CommonUtils/basics/VariableRadio.vue';
Vue.component('fc-radio', vRadio);

import vTextArea from './CommonUtils/basics/VariableTextArea.vue';
Vue.component('fc-textarea', vTextArea);

import vCheckBox from './CommonUtils/basics/VariableCheckBox.vue';
Vue.component('fc-checkbox', vCheckBox);

import vOneCheckBox from './CommonUtils/basics/VariableOneCheckBox.vue';
Vue.component('fc-onecheckbox', vOneCheckBox);

import vDatePicker from './CommonUtils/basics/VariableDatePicker.vue';
Vue.component('fc-date', vDatePicker);

import vFileInput from './CommonUtils/basics/VariableFileInput.vue';
Vue.component('fc-fileinput', vFileInput);

import variableScreen from './CommonUtils/basics/VariableScreen.vue';
Vue.component('variableScreen', variableScreen);

import variableGroup from './CommonUtils/basics/VariableGroup.vue';
Vue.component('variableGroup', variableGroup);

import variableList from './CommonUtils/basics/VariableList.vue';
Vue.component('variableList', variableList);

import variableTableList from './CommonUtils/basics/VariableTableList.vue';
Vue.component('variableTableList', variableTableList);

import vNumberInput from './CommonUtils/basics/VariableNumber.vue';
Vue.component('fc-number', vNumberInput);

import vHidden from './CommonUtils/basics/VariableHidden.vue';
Vue.component('fc-hidden', vHidden);

import vDisplayText from './CommonUtils/basics/VariableDisplayText.vue';
Vue.component('fc-display', vDisplayText);

import screenTop from './CommonUtils/components/CommonScreenTop.vue';
Vue.component('screenTop', screenTop);
// 2023.07.21 [2023F-06] add start
import vSelectM from './CommonUtils/basics/VariableSelectChangeEvent.vue';
Vue.component('fc-selectM', vSelectM);
// 2023.07.21 [2023F-06] add end
// 2023.10.20 [2023L-04] add start
import vMultiFileInput from './CommonUtils/basics/VariableMultiFileInput.vue';
Vue.component('vMultiFileInput', vMultiFileInput);
import variableScreenOfMultiFile from './CommonUtils/basics/VariableScreenOfMultiFile.vue';
Vue.component('variableScreenOfMultiFile', variableScreenOfMultiFile);
//  2023.10.20 [2023L-04] add end

Vue.config.productionTip = false;
//20250326 [multipleTabs] sha331 add start
if (localStorage) {
  onstorage = (event) => {
    if (event.key === 'loginSuccess') {
      router.push({name: 'no_auth/multipleTabsError'});
    }
  };
}
//20250326 [multipleTabs] sha331 add end
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(cyd2),
}).$mount('#cyd2');
